import { createNamespacedHelpers } from 'vuex';

const {
  mapActions: mapContactsAccountManagementActions,
  mapState: mapContactsAccountManagementState,
  mapMutations: mapContactsAccountManagementMutations,
} = createNamespacedHelpers('contactsAccountManagement');

export default {
  computed: {
    ...mapContactsAccountManagementState({
      affectedContacts: 'total',
      affectedContactsHasErr: 'hasError',
      affectedContactsErrMsg: 'errorMsg',
      affectedContactsIsLoading: 'isLoading',
    }),
  },
  methods: {
    ...mapContactsAccountManagementMutations({
      clearAffectedContactsMessage: 'clearMessages',
    }),
    ...mapContactsAccountManagementActions(['findTotalContactsByResource']),
  },
};
